import React from 'react';
import { UserShape } from '../shapes';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Waiting from '../components/waiting';
import GoTo from '../components/go_to';

export default class MagicLink extends React.Component {
  static propTypes = {
    user: UserShape,
    params: PropTypes.object,
    onLoginWithMagicLink: PropTypes.func
  }

  componentDidMount() {
    this.props.onLoginWithMagicLink(this.props.params.token);
  }

  render() {
    if (this.props.user.get('loggedIn')) {
      return this.renderLoggedIn();
    } else if (this.props.user.get('error')) {
      return this.renderLoginError();
    } else {
      return this.renderLoggingIn();
    }
  }

  renderLoggedIn() {
    if (this.props.params.go_to) {
      return this.renderAfterLoggedInRedirect();
    } else {
      return this.renderAfterLoggedInConfirmation();
    }
  }

  renderAfterLoggedInConfirmation() {
    return(
      <div className='row magic-link-confirmation'>
        <div className='col-sm-12'>
          Ok, you're logged in!
        </div>
        <div className='col-sm-12 action'>
          <Link to='/' className='btn btn-dark' data-primary-cta='true'>Got It</Link>
        </div>
      </div>
    )
  }

  renderAfterLoggedInRedirect() {
    if (this.props.params.go_to) {
      return (
        <GoTo pathKey={ this.props.params.go_to } />
      );
    } else {
      return this.renderAfterLoggedInConfirmation();
    }
  }

  renderLoggingIn() {
    return(<Waiting waitingText={ 'Logging In' } />);
  }

  renderLoginError() {
    return(
      <div className='magic-link-confirmation'>
        Hmm, we had a problem logging you in. Try again?
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/magic_link.jsx